import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { Icon } from "./Icon";
import { DiscordIcon } from "./DiscordIcon";
import { staggerChild } from "./Reveal";

export const ProductCard = ({ product, info, labels, onOpen, onBuy }) => (
  <motion.article
    variants={staggerChild}
    data-testid={`product-card-${product.id}`}
    onClick={() => onOpen(product)}
    className="group relative flex flex-col rounded-2xl border border-white/[0.06] bg-[#0a0e14] p-7 md:p-8 cursor-pointer transition-colors duration-300 hover:border-cyan-500/30 hover:bg-[#0c1119] hover:shadow-[0_0_28px_rgba(56,189,248,0.10)]"
  >
    {product.popular && (
      <span
        data-testid={`popular-${product.id}`}
        className="absolute -top-3 left-7 bg-brand text-[#080a0f] font-mono text-[10px] font-semibold tracking-[0.15em] px-3 py-1 rounded-full"
      >
        POPULAR
      </span>
    )}

    <div className="flex items-start justify-between mb-7">
      <span className="h-12 w-12 rounded-xl bg-cyan-500/10 border border-cyan-500/20 grid place-items-center text-cyan-400 transition-transform duration-300 group-hover:-translate-y-0.5">
        <Icon name={product.icon} className="h-5 w-5" />
      </span>
      <span className="font-mono text-[11px] tracking-widest uppercase text-slate-500">{info.tag}</span>
    </div>

    <h3 className="font-display font-bold text-xl tracking-tight">{info.title}</h3>
    <p className="mt-3 text-sm text-slate-400 leading-relaxed">{info.short}</p>

    <ul className="mt-6 space-y-2.5 flex-1">
      {info.features.map((f) => (
        <li key={f} className="flex items-start gap-2.5 text-sm text-slate-300">
          <Check className="h-4 w-4 text-cyan-400 mt-0.5 shrink-0" />
          {f}
        </li>
      ))}
    </ul>

    <div className="mt-8 pt-6 border-t border-white/5 flex items-end justify-between">
      <div>
        <div className="font-mono text-[11px] uppercase tracking-widest text-slate-500">{labels.price}</div>
        <div className="mt-1 font-display font-bold text-2xl text-gradient">{info.price}</div>
      </div>
      <button
        data-testid={`buy-${product.id}`}
        onClick={(e) => { e.stopPropagation(); onBuy(product); }}
        className="bg-brand text-[#080a0f] font-semibold text-sm px-4 py-2.5 rounded-full flex items-center gap-2 hover:shadow-[0_0_22px_rgba(56,189,248,0.45)] transition-shadow duration-300 active:scale-[0.97]"
      >
        <DiscordIcon className="h-4 w-4" />
        {labels.buy}
      </button>
    </div>
  </motion.article>
);
